module.exports = __webpack_public_path__ + "static/img/icon-shop-unapply.06c12af4.png";